/**
 * Blue Tees Golf - Global Accessibility Suite (a11y-suite.js)
 * Consolidates all accessibility patches sitewide
 */

// 1. Owl Carousel Screen Reader & Autoplay Controls Patch
(function () {
  if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.owlCarousel) {
    var originalOwl = jQuery.fn.owlCarousel;
    jQuery.fn.owlCarousel = function (options) {
      options = options || {};
      var $carousel = this;
      $carousel.each(function () {
        var $el = jQuery(this);
        $el.attr('role', 'region');
        $el.attr('aria-roledescription', 'carousel');
        if (!$el.attr('aria-label') && !$el.attr('aria-labelledby')) {
          var titleText = 'Image slider';
          var section = $el.closest('section, .shopify-section, .new-offer_main');
          if (section.length) {
            var heading = section.find('h1, h2, h3').first();
            if (heading.length) {
              titleText = heading.text().trim() + ' gallery';
            }
          }
          $el.attr('aria-label', titleText);
        }
      });

      if (options.autoplay === true) {
        $carousel.on('initialized.owl.carousel', function (event) {
          setTimeout(function () {
            var $dots = $carousel.find('.owl-dots');
            var $nav = $carousel.find('.owl-nav');
            var $btn = $(
              '<button type="button" class="owl-autoplay-btn" aria-label="Pause slideshow" aria-pressed="false">' +
                '<svg class="pause-icon" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.5" y="0.5" width="2" height="9" fill="currentColor"/><rect x="6.5" y="0.5" width="2" height="9" fill="currentColor"/></svg>' +
                '<svg class="play-icon" style="display:none;" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1L8.5 5L2.5 9V1Z" fill="currentColor"/></svg>' +
                '</button>'
            );

            if ($dots.length > 0) {
              $dots.after($btn);
            } else if ($nav.length > 0) {
              $nav.append($btn);
            } else {
              $carousel.append($btn);
            }

            $btn.on('click', function () {
              var isPaused = $btn.attr('aria-pressed') === 'true';
              if (isPaused) {
                $carousel.trigger('play.owl.autoplay');
                $btn.attr('aria-pressed', 'false');
                $btn.attr('aria-label', 'Pause slideshow');
                $btn.find('.pause-icon').show();
                $btn.find('.play-icon').hide();
              } else {
                $carousel.trigger('stop.owl.autoplay');
                $btn.attr('aria-pressed', 'true');
                $btn.attr('aria-label', 'Play slideshow');
                $btn.find('.pause-icon').hide();
                $btn.find('.play-icon').show();
              }
            });
          }, 300);
        });
      }
      return originalOwl.apply(this, arguments);
    };
  }

  // Live announcer for carousel updates
  let announcer = document.getElementById('carousel-live-announcer');
  if (!announcer) {
    announcer = document.createElement('div');
    announcer.id = 'carousel-live-announcer';
    announcer.className = 'visually-hidden';
    announcer.setAttribute('aria-live', 'polite');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.style.position = 'absolute';
    announcer.style.width = '1px';
    announcer.style.height = '1px';
    announcer.style.padding = '0';
    announcer.style.margin = '-1px';
    announcer.style.overflow = 'hidden';
    announcer.style.clip = 'rect(0, 0, 0, 0)';
    announcer.style.border = '0';
    document.body.appendChild(announcer);
  }

  function announceSlideChange(message) {
    if (announcer) {
      announcer.textContent = '';
      setTimeout(() => {
        announcer.textContent = message;
      }, 50);
    }
  }

  function updateOwlDots(dotsContainer) {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.owl-dot');
    let activeIdx = -1;

    dots.forEach((dot, index) => {
      const slideNum = index + 1;
      const labelText = 'Go to slide ' + slideNum;
      if (dot.getAttribute('aria-label') !== labelText) {
        dot.setAttribute('aria-label', labelText);
      }

      const isActive = dot.classList.contains('active');
      if (isActive) {
        activeIdx = index;
        if (dot.getAttribute('aria-current') !== 'true') {
          dot.setAttribute('aria-current', 'true');
        }
      } else {
        if (dot.hasAttribute('aria-current')) {
          dot.removeAttribute('aria-current');
        }
      }
    });

    if (activeIdx !== -1 && dots.length > 0) {
      const slideNum = activeIdx + 1;
      const totalSlides = dots.length;
      const lastAnnounced = dotsContainer.getAttribute('data-last-announced');

      if (lastAnnounced !== String(slideNum)) {
        dotsContainer.setAttribute('data-last-announced', slideNum);
        const carousel = dotsContainer.closest('.owl-carousel');
        let title = '';
        if (carousel) {
          title = carousel.getAttribute('aria-label') || carousel.getAttribute('title');
          if (!title) {
            const section = carousel.closest('section, .shopify-section, .new-offer_main');
            if (section) {
              const heading = section.querySelector('h1, h2, h3');
              if (heading) {
                title = heading.textContent.trim();
              }
            }
          }
        }
        title = title || 'Carousel';
        if (title.length > 50) {
          title = title.substring(0, 47) + '...';
        }
        announceSlideChange(title + ': Slide ' + slideNum + ' of ' + totalSlides);
      }
    }
  }

  function updateOwlNav(navContainer) {
    if (!navContainer) return;
    const prevBtn = navContainer.querySelector('.owl-prev');
    const nextBtn = navContainer.querySelector('.owl-next');

    if (prevBtn) {
      if (prevBtn.getAttribute('role') === 'presentation') {
        prevBtn.removeAttribute('role');
      }
      if (!prevBtn.hasAttribute('aria-label') || prevBtn.getAttribute('aria-label') === 'Previous') {
        prevBtn.setAttribute('aria-label', 'Previous slide');
      }
      prevBtn.querySelectorAll('img').forEach((img) => {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
      });
    }

    if (nextBtn) {
      if (nextBtn.getAttribute('role') === 'presentation') {
        nextBtn.removeAttribute('role');
      }
      if (!nextBtn.hasAttribute('aria-label') || nextBtn.getAttribute('aria-label') === 'Next') {
        nextBtn.setAttribute('aria-label', 'Next slide');
      }
      nextBtn.querySelectorAll('img').forEach((img) => {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
      });
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList.contains('owl-dots')) {
              updateOwlDots(node);
            } else {
              node.querySelectorAll('.owl-dots').forEach(updateOwlDots);
            }
            if (node.classList.contains('owl-nav')) {
              updateOwlNav(node);
            } else {
              node.querySelectorAll('.owl-nav').forEach(updateOwlNav);
            }
          }
        });
      } else if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('owl-dot')) {
          updateOwlDots(target.closest('.owl-dots'));
        }
        if (target.classList.contains('owl-prev') || target.classList.contains('owl-next')) {
          updateOwlNav(target.closest('.owl-nav'));
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.owl-prev, .owl-next');
    if (trigger) {
      const carousel = trigger.closest('.owl-carousel');
      if (carousel) {
        setTimeout(() => {
          const items = Array.from(carousel.querySelectorAll('.owl-item'));
          items.forEach((item) => {
            const isActive = item.classList.contains('active');
            if (isActive) {
              item.removeAttribute('inert');
              item.removeAttribute('aria-hidden');
              item.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((focusable) => {
                if (focusable.dataset.prevTabindex !== undefined) {
                  focusable.setAttribute('tabindex', focusable.dataset.prevTabindex);
                } else {
                  focusable.removeAttribute('tabindex');
                }
              });
            } else {
              item.setAttribute('inert', 'true');
              item.setAttribute('aria-hidden', 'true');
              item.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((focusable) => {
                if (!focusable.hasAttribute('data-prev-tabindex')) {
                  focusable.setAttribute('data-prev-tabindex', focusable.getAttribute('tabindex') || '0');
                }
                focusable.setAttribute('tabindex', '-1');
              });
            }
          });
        }, 300);
      }
    }
  });

  const slideObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('owl-item')) {
          const isActive = target.classList.contains('active');
          if (isActive) {
            target.removeAttribute('inert');
            target.removeAttribute('aria-hidden');
            target.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((focusable) => {
              if (focusable.dataset.prevTabindex !== undefined) {
                focusable.setAttribute('tabindex', focusable.dataset.prevTabindex);
              } else {
                focusable.removeAttribute('tabindex');
              }
            });
          } else {
            target.setAttribute('inert', 'true');
            target.setAttribute('aria-hidden', 'true');
            target.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((focusable) => {
              if (!focusable.hasAttribute('data-prev-tabindex')) {
                focusable.setAttribute('data-prev-tabindex', focusable.getAttribute('tabindex') || '0');
              }
              focusable.setAttribute('tabindex', '-1');
            });
          }
        }
      }
    });
  });

  slideObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  document.querySelectorAll('.owl-dots').forEach(updateOwlDots);
  document.querySelectorAll('.owl-carousel').forEach((carousel) => {
    carousel.querySelectorAll('.owl-item').forEach((item) => {
      const isActive = item.classList.contains('active');
      if (isActive) {
        item.removeAttribute('inert');
        item.removeAttribute('aria-hidden');
      } else {
        item.setAttribute('inert', 'true');
        item.setAttribute('aria-hidden', 'true');
        item.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((focusable) => {
          focusable.setAttribute('data-prev-tabindex', focusable.getAttribute('tabindex') || '0');
          focusable.setAttribute('tabindex', '-1');
        });
      }
    });
  });
})();

// 2. Loop Subscriptions Accessibility
(function () {
  if (!window.location.pathname.includes('/a/loop_subscriptions')) return;

  function fixLoopPageAccessibility() {
    const paragraphs = document.querySelectorAll('p.loop-h2, div.loop-h2, span.loop-h2, .loop-h2');
    paragraphs.forEach((el) => {
      if (el.tagName !== 'H1' && el.textContent.trim().includes('Request Subscription Login Link')) {
        const h1 = document.createElement('h1');
        Array.from(el.attributes).forEach((attr) => {
          h1.setAttribute(attr.name, attr.value);
        });
        h1.innerHTML = el.innerHTML;
        el.parentNode.replaceChild(h1, el);
      }
    });

    const errorElements = document.querySelectorAll('.loop-text-p1.text-danger, .loop-text-p1.mt-4.text-danger');
    errorElements.forEach((errorEl, index) => {
      if (!errorEl.id) {
        errorEl.id = 'loop-error-msg-' + index;
      }
      if (!errorEl.getAttribute('role')) {
        errorEl.setAttribute('role', 'alert');
      }
      if (!errorEl.getAttribute('aria-live')) {
        errorEl.setAttribute('aria-live', 'assertive');
      }

      const container = errorEl.closest('form, div');
      if (container) {
        const input = container.querySelector('input[type="email"], input[name="email"], input');
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          const existingDescribedBy = input.getAttribute('aria-describedby') || '';
          if (!existingDescribedBy.split(' ').includes(errorEl.id)) {
            input.setAttribute('aria-describedby', (existingDescribedBy + ' ' + errorEl.id).trim());
          }
        }
      }
    });

    const inputs = document.querySelectorAll('input[type="email"], input[name="email"]');
    inputs.forEach((input) => {
      const container = input.closest('form, div');
      if (container) {
        const hasVisibleError = container.querySelector(
          '.loop-text-p1.text-danger, .loop-text-p1.mt-4.text-danger'
        );
        if (!hasVisibleError && input.getAttribute('aria-invalid') === 'true') {
          input.removeAttribute('aria-invalid');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLoopPageAccessibility);
  } else {
    fixLoopPageAccessibility();
  }

  const loopObserver = new MutationObserver(() => {
    fixLoopPageAccessibility();
  });

  loopObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();

// 3. Klaviyo Form Accessibility
(function () {
  function enhanceKlaviyoFormAccessibility() {
    const formContainers = document.querySelectorAll(
      '.klaviyo-form, [class*="klaviyo-form"], [data-testid="klaviyo-form"], form.kl-private-reset-css-Xuajs1'
    );

    formContainers.forEach((container) => {
      if (!container.dataset.a11yObserved) {
        container.dataset.a11yObserved = 'true';

        if (!container.getAttribute('aria-live')) {
          container.setAttribute('aria-live', 'polite');
        }
        if (!container.getAttribute('role')) {
          container.setAttribute('role', 'status');
        }

        const observer = new MutationObserver(() => {
          const successText = container.querySelector('.klaviyo-form-richtext, [data-testid="form-component"]');
          const formInputs = container.querySelector('input, button[type="submit"]');

          if (successText && !formInputs && !successText.dataset.a11yFocused) {
            successText.dataset.a11yFocused = 'true';
            successText.setAttribute('tabindex', '-1');
            successText.setAttribute('role', 'status');
            successText.setAttribute('aria-live', 'polite');

            setTimeout(() => {
              successText.focus({ preventScroll: false });
            }, 150);
          }
        });

        observer.observe(container, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceKlaviyoFormAccessibility);
  } else {
    enhanceKlaviyoFormAccessibility();
  }

  window.addEventListener('klaviyoForms', function (e) {
    enhanceKlaviyoFormAccessibility();
    if (e.detail && (e.detail.type === 'submit' || e.detail.type === 'stepSubmit')) {
      setTimeout(enhanceKlaviyoFormAccessibility, 300);
    }
  });

  const bodyObserver = new MutationObserver(() => {
    enhanceKlaviyoFormAccessibility();
  });

  if (document.body) {
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();

// 4. Video Nested Controls & Modal Popups Accessibility Suite
(function () {
  // Fix nested interactive controls on video containers
  function fixVideoNestedControls() {
    const videoBlocks = document.querySelectorAll(
      '.video_block, .video-preview, [data-play-in-place], .video_section-home, .custom-video-content__video-container'
    );

    videoBlocks.forEach((block) => {
      const hasNestedButton = block.querySelector(
        'button, a, .play-button, .play-pause-overlay-btn, .video_overlay-content'
      );

      if (hasNestedButton) {
        if (block.getAttribute('role') === 'button') {
          block.removeAttribute('role');
        }
        if (block.hasAttribute('tabindex') && block.getAttribute('tabindex') !== '-1') {
          block.removeAttribute('tabindex');
        }
        if (block.hasAttribute('aria-label')) {
          block.removeAttribute('aria-label');
        }
      }

      const overlays = block.querySelectorAll('.video_overlay-holder, .video_overlay-content, .play-button');
      overlays.forEach((overlay) => {
        const childBtn = overlay.querySelector('button, a, .play-button, .play-pause-overlay-btn');
        if (childBtn && childBtn !== overlay) {
          if (overlay.getAttribute('role') === 'button') {
            overlay.removeAttribute('role');
          }
          if (overlay.hasAttribute('tabindex') && overlay.getAttribute('tabindex') !== '-1') {
            overlay.removeAttribute('tabindex');
          }
          if (overlay.hasAttribute('aria-label')) {
            overlay.removeAttribute('aria-label');
          }
        }
      });
    });
  }

  // Attach invisible focus guard sentinels around modals to block any escape to footer/body
  function attachModalFocusGuards(modal) {
    if (!modal || modal.dataset.a11yGuarded) return;
    modal.dataset.a11yGuarded = 'true';

    let startGuard = modal.querySelector('.a11y-modal-guard-start');
    if (!startGuard) {
      startGuard = document.createElement('div');
      startGuard.className = 'a11y-modal-guard-start';
      startGuard.tabIndex = 0;
      startGuard.setAttribute('aria-hidden', 'true');
      startGuard.style.cssText = 'position: absolute; top: 0; left: 0; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); border: 0; outline: none;';
      modal.insertBefore(startGuard, modal.firstChild);
    }

    let endGuard = modal.querySelector('.a11y-modal-guard-end');
    if (!endGuard) {
      endGuard = document.createElement('div');
      endGuard.className = 'a11y-modal-guard-end';
      endGuard.tabIndex = 0;
      endGuard.setAttribute('aria-hidden', 'true');
      endGuard.style.cssText = 'position: absolute; bottom: 0; right: 0; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); border: 0; outline: none;';
      modal.appendChild(endGuard);
    }

    startGuard.addEventListener('focus', function () {
      const focusables = getModalFocusables(modal);
      if (focusables.length > 0) {
        focusables[focusables.length - 1].focus();
      }
    });

    endGuard.addEventListener('focus', function () {
      const focusables = getModalFocusables(modal);
      if (focusables.length > 0) {
        focusables[0].focus();
      }
    });
  }

  function ensureModalVideoFocusable() {
    const modals = document.querySelectorAll(
      '.pop-upbox, .dialog-video-popup, [role="dialog"], .modal-video, .upsell-modal, .custom_popup, #video-popup'
    );

    modals.forEach((modal) => {
      attachModalFocusGuards(modal);

      const videos = modal.querySelectorAll('video');
      videos.forEach((video) => {
        if (video.hasAttribute('controls') && !video.hasAttribute('tabindex')) {
          video.setAttribute('tabindex', '0');
        }
      });
    });
  }

  // Robust universal modal focus trap & focus containment
  function getActiveModal() {
    const candidateModals = document.querySelectorAll(
      '.pop-upbox, .dialog-video-popup.active, [role="dialog"], .modal-video, .upsell-modal, .upsell_popup--new, .custom_popup'
    );
    for (let i = 0; i < candidateModals.length; i++) {
      const modal = candidateModals[i];
      const style = window.getComputedStyle(modal);
      if (style.display !== 'none' && style.visibility !== 'hidden' && (modal.offsetWidth > 0 || modal.offsetHeight > 0)) {
        return modal;
      }
    }
    return null;
  }

  function getModalFocusables(modal) {
    const selector = 'a[href]:not([disabled]):not(.a11y-modal-guard-start):not(.a11y-modal-guard-end), button:not([disabled]):not(.a11y-modal-guard-start):not(.a11y-modal-guard-end), video[controls], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not(.a11y-modal-guard-start):not(.a11y-modal-guard-end)';
    return Array.from(modal.querySelectorAll(selector)).filter(
      (el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0 || el.tagName === 'VIDEO' || el === document.activeElement
    );
  }

  // Trap focus strictly within open modal when tabbing
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' && e.keyCode !== 9) return;

    const activeModal = getActiveModal();
    if (!activeModal) return;

    attachModalFocusGuards(activeModal);

    const focusables = getModalFocusables(activeModal);
    if (focusables.length === 0) {
      e.preventDefault();
      return;
    }

    const firstEl = focusables[0];
    const lastEl = focusables[focusables.length - 1];

    // If focus is outside modal, immediately bring it to first element
    if (!activeModal.contains(document.activeElement)) {
      e.preventDefault();
      e.stopPropagation();
      firstEl.focus();
      return;
    }

    if (e.shiftKey) {
      // Shift + Tab backward
      if (document.activeElement === firstEl) {
        e.preventDefault();
        e.stopPropagation();
        lastEl.focus();
      }
    }
  }, true);

  // Track opener element so focus reliably returns to it after modal closes instead of falling to body/footer
  let modalOpenerTrigger = null;

  function trackModalOpener(e) {
    const trigger = e.target.closest('.poptrigger, [data-rel], [data-video-url], [data-play-in-place], .video-preview, .play-button, .play-pause-overlay-btn, [aria-haspopup="dialog"], [data-target-modal]');
    if (trigger) {
      modalOpenerTrigger = trigger;
    }
  }

  document.addEventListener('click', trackModalOpener, true);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      trackModalOpener(e);
    }
  }, true);

  // Focus containment: Intercept focus on capture phase before any footer/page elements receive focus
  window.addEventListener('focusin', function (e) {
    const activeModal = getActiveModal();
    if (activeModal && !activeModal.contains(e.target)) {
      const focusables = getModalFocusables(activeModal);
      if (focusables.length > 0) {
        e.stopImmediatePropagation();
        focusables[0].focus();
      }
    }
  }, true);

  // Restore focus to opener trigger when modal closes
  function restoreFocusAfterModalClose() {
    setTimeout(() => {
      if (modalOpenerTrigger && typeof modalOpenerTrigger.focus === 'function') {
        modalOpenerTrigger.focus();
        modalOpenerTrigger = null;
      }
    }, 50);
  }

  // Hook into close clicks
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.closePop, .pop-close a, .pop-close button, .close-button, .close, [aria-label*="Close"], #fade');
    if (closeBtn) {
      restoreFocusAfterModalClose();
    }
  });

  // Escape key support
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      const activeModal = getActiveModal();
      if (activeModal) {
        e.preventDefault();
        const closeBtn = activeModal.querySelector('.closePop, .pop-close a, .pop-close button, .close-button, .close, [aria-label*="Close"]');
        if (closeBtn) {
          closeBtn.click();
        } else if (window.jQuery) {
          window.jQuery(activeModal).fadeOut(200, restoreFocusAfterModalClose);
        } else {
          activeModal.style.display = 'none';
          restoreFocusAfterModalClose();
        }
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      fixVideoNestedControls();
      ensureModalVideoFocusable();
    });
  } else {
    fixVideoNestedControls();
    ensureModalVideoFocusable();
  }

  const videoObserver = new MutationObserver(() => {
    fixVideoNestedControls();
    ensureModalVideoFocusable();
  });

  if (document.body) {
    videoObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['role', 'tabindex', 'aria-label', 'style', 'class'] });
  }
})();

// 5. Sitewide Swatch & Radio Button Accessible Name Safeguard
(function () {
  function fixSwatchAccessibleNames() {
    // 1. Radio buttons inside swatches / variant buttons
    const radioSwatches = document.querySelectorAll('input[type="radio"][name*="quick_add_color"], input[type="radio"].variant__input--color-swatch, .variant-input-wrap input[type="radio"], [data-quick-add-swatches] input[type="radio"]');
    radioSwatches.forEach((input) => {
      let colorName = input.getAttribute('data-color-name') || input.value;
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (!colorName && label) {
        colorName = label.textContent.trim() || label.getAttribute('aria-label');
      }
      if (colorName && !input.getAttribute('aria-label')) {
        input.setAttribute('aria-label', colorName.trim());
      }
      if (label && colorName && !label.getAttribute('aria-label')) {
        label.setAttribute('aria-label', colorName.trim());
      }
    });

    // 2. Anchor swatch links
    const linkSwatches = document.querySelectorAll('a.color-swatch, .grid-product__colors a');
    linkSwatches.forEach((swatch) => {
      const hiddenText = swatch.querySelector('.visually-hidden, .sr-only');
      if (hiddenText && hiddenText.textContent.trim() && !swatch.getAttribute('aria-label')) {
        swatch.setAttribute('aria-label', hiddenText.textContent.trim());
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSwatchAccessibleNames);
  } else {
    fixSwatchAccessibleNames();
  }

  const swatchObserver = new MutationObserver(() => {
    fixSwatchAccessibleNames();
  });

  if (document.body) {
    swatchObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
